import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/payroll-core-mock/_layout/dashboard/')({
  component: () => null
});